module.exports = __webpack_public_path__ + "img/login_logo.7b4a6e44.png";